import * as React from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const ClassicReenrollmentLegacyEventFilterRenderer = ({
  reEnrollmentTriggerSet
}) => {
  return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "flow-doctor-lib.reEnrollmentTriggerSets.legacyCBE",
    options: {
      eventId: reEnrollmentTriggerSet[0].id
    }
  });
};
export default ClassicReenrollmentLegacyEventFilterRenderer;